import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, Validator } from 'redux-form';
import { ThemeContext } from 'styled-components';

import { InputStyles } from 'lib/interfaces/input-styles';
import PiiAttributes from 'lib/interfaces/PiiAttributes';
import FormGroup from 'verify/components/FormGroup';
import ThemedFormInput from 'verify/components/ThemedFormInput';

interface ThemedFormEmailAddressInputProps {
  disabled: boolean;
  validate: {
    emailAddress: Validator | Validator[];
  };
}

const ThemedFormEmailAddressInput = ({ disabled, validate }: ThemedFormEmailAddressInputProps) => {
  const [t] = useTranslation();

  const { inputStyle } = useContext(ThemeContext);
  const hideLabel = inputStyle === InputStyles.Material;

  return (
    <FormGroup>
      {!hideLabel && (
        <label htmlFor={PiiAttributes.EmailAddress}>{t('email-address.form.label')}</label>
      )}
      <Field
        name={PiiAttributes.EmailAddress}
        component={ThemedFormInput}
        disabled={disabled}
        placeholder={t('email-address.form.label')}
        type='email'
        validate={validate.emailAddress}
      />
    </FormGroup>
  );
};

export default ThemedFormEmailAddressInput;
